<template>
  <div>
    <canvas :id="name" :height="height"></canvas>
    <div class="axis">
      <div v-for="(x, key) in data.labels" :key="x" class="tick">
        {{ x }}
        <span class="value value--this">{{ data.datasets[0].data[key] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'

require('../../../static/js/dashboard.js')

/* eslint-disable */
export default {
  props: [
    'name',
    'boldTitle',
    'height',
    'clearState',
    'legend',
    'fullview',
    'startDate',
    'endDate',
  ],
  store,
  components: {},
  mounted() {
    this.loadData()
  },
  watch: {
    '$store.getters.datepicker.dashboard': {
      handler: function (date) {
        this.startDate = date.startDate
        this.endDate = date.endDate
        this.changePeriod()
      },
      deep: true,
    },
  },
  methods: {
    changePeriod: function (value) {
      this.option = value
      // console.log(value)
      this.clearState = true
      this.loadData()
      this.clearState = false
    },
    loadData: function () {
      let options = {
        widget_id: this.$session.get('widget_id'),
      }

      this.loading = true

      this.$http
        .post(process.env.API_ENDPOINT + '/report/monthly', options)
        .then((response) => {
          this.pageview = response.data
          this.$emit('data', response.data)
          this.loadChart()
        })
    },
    loadChart: function () {
      const ctx2 = document.getElementById(this.name).getContext('2d')
      const gradient = ctx2.createLinearGradient(0, 0, 0, 450)
      gradient.addColorStop(
        0,
        'rgba(' + localStorage.getItem('--main-color') + ',.5)'
      )
      gradient.addColorStop(
        1,
        'rgba(' + localStorage.getItem('--main-color') + ',0)'
      )

      var multiply = {
        beforeDatasetsDraw: function (chart, options, el) {
          chart.ctx.globalCompositeOperation = 'multiply'
        },
        afterDatasetsDraw: function (chart, options) {
          chart.ctx.globalCompositeOperation = 'source-over'
        },
      }

      let best = ''
      let worst = ''
      var pageview = 0
      var borderColor = ''
      var bgColor = ''

      var data = {
        labels: [],
        datasets: [
          {
            data: [],
          },
          {
            data: [],
          },
          {
            data: [],
          },
        ],
      }
      var monthNames = [
        '',
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ]

      var today = new Date()
      var d
      var month

      for (var i = 5; i >= 0; i -= 1) {
        d = new Date(today.getFullYear(), today.getMonth() - i, 1)
        month = monthNames[d.getMonth() + 1]
        data.labels.push(month)
      }

      let j = 0

      for (let i in this.pageview) {
        let current = this.pageview[i]

        pageview = this.precisionRound(current.value, 1)

        let currentdate = current.date
        if (!data.labels.includes(monthNames[currentdate])) continue

        while (
          typeof data.labels[j] !== 'undefined' &&
          monthNames[currentdate] != data.labels[j]
        ) {
          data.datasets[0].data.push(0)
          j++
        }

        data.datasets[0].data.push(pageview)

        data.datasets[0].lineTension = 0.4
        data.datasets[0].backgroundColor = gradient
        data.datasets[0].borderColor = 'transparent'
        data.datasets[0].pointBackgroundColor = '#FFFFFF'
        data.datasets[0].pointBorderColor = '#FFFFFF'
        data.datasets[0].label = this.t('Pageviews')

        j++
      }

      for (let i in data.labels) {
        if (!data.datasets[0].data[i]) {
          data.datasets[0].data[i] = 0
        }
      }

      if (this.chart !== undefined) this.chart.destroy()
      let ctx = document.getElementById(this.name)

      import('chart.js').then(Chart => {
        this.chart = new Chart(ctx, {
          // eslint-disable-line no-new
          type: 'line',
          data: data,
          options: {
            tooltips: {
              mode: 'index',
              intersect: false,
            },
            hover: {
              mode: 'nearest',
              intersect: true,
            },
            // elements: {
            //   point: {
            //     radius: 5,
            //   },
            // },
            maintainAspectRatio: false,
            onClick: function (evt, item) {
              if (item[0]) {
                let label = data.labels[item[0]['_index']]
              }
            },
            elements: {
              point: {
                radius: 0,
                hitRadius: 5,
                hoverRadius: 5,
              },
            },
            legend: {
              display: false,
            },
            scales: {
              xAxes: [
                {
                  display: false,
                },
              ],
              yAxes: [
                {
                  display: false,
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
            defaultFontSize: 16,
            layout: {
              padding: {
                top: 30,
              },
            },
          },
          plugins: [multiply],
        })
      })
      this.data = data
    },
    diff: function (date1, date2) {
      let dt1 = new Date(date1)
      let dt2 = new Date(date2)
      return Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      )
    },
    precisionRound: function (number, precision) {
      var factor = Math.pow(10, precision)
      return Math.round(number * factor) / factor
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
  data: function () {
    return {
      option: 'all',
      chart: undefined,
      clearState: false,
      startDate: '',
      endDate: '',
      pageview: null,
      uniqueview: null,
      loading: true,
      data: [],
    }
  },
}
</script>

<style scoped>
.legends {
  padding-top: 20px;
  overflow: hidden;
}

.legend {
  display: block;
  width: 8px;
  height: 8px;
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: 50%;
}

.legend--this {
  background-color: #5555ff;
}

.legend--prev {
  background-color: #ff55b8;
}

.axis {
  position: absolute;
  color: #000;
  z-index: 1;
  text-transform: uppercase;
  display: flex;
  width: 92%;
  bottom: 0;
}

.axis .tick {
  flex: 1;
  position: relative;
  overflow: hidden;
  opacity: 0.7;
  font-size: 11px;
  text-align: center;
  line-height: 40px;
  padding-top: 200px;
}

.axis .tick:hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.2);
}

.axis .tick .value {
  transform: translateY(-40px);
  transition: 0.3s transform;
  position: absolute;
  top: 20px;
  color: rgb(24, 24, 24);
  border-radius: 2px;
  width: 100%;
  line-height: 20px;
}

.axis .tick:hover .value.value--this {
  transform: translateY(0);
  display: block;
}

.value.value--this {
  color: #5555ff;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/MonthlyChart.vue